import React, {useEffect, useState} from 'react'

export const useFetchEmailContent = (fetchFunc) => {
    const [content, setContent] = useState(null)
    const [attachments, setAttachments] = useState([])

    useEffect(function fetchResource(){
        fetchFunc().then( ({content, attachments}) => {
            setContent(content)
            setAttachments(attachments)
        })
    }, [])

    return {content, attachments}
}